import React from 'react';
import { Stack, Typography, Card, CardContent, Divider, CardHeader, Box } from '@mui/material';
import { useStaff } from '../../pages/Staff';
import { useManager } from '../../pages/Manager';

const StaffCamps = ({ manager }) => {
  const { application } = manager ? useManager() : useStaff();
  if (!application) {
    return null;
  }

  const hideSunActivePoints = application => [6].includes(application.function_type) || application.periods_type === 'zielone_szkoly'; // 6 - manager
  // const hideSunActivePoints = () => false;
  const renderCamps = resort => application.ol_periods.map((ol, key) => {
    const camp = application.ol_periods_choices.find(olc => olc.value == ol);

    if (!camp.label.includes(resort)) {
      return;
    }
    const sunActivePoints = camp.sunactive_points.reduce((total, s) => total + s.value, 0);
    const timedPeriod = application.ol_timed_periods.find(ot => ot.id == ol);

    return (
      <Card key={key} style={{ margin: '20px', border: '1px solid #e0e0e0', borderRadius: '8px', width: '70%' }}>
        {hideSunActivePoints(application)
          ? <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
            {/* GÓRA */}
            <Box
              sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                px: 2,
                py: 1.5,
                textAlign: 'center'
              }}
            >
              <Typography variant="h6">
                OL - {resort}
              </Typography>
            </Box>

            {/* DÓŁ */}
            <Box sx={{ px: 2, py: 2, textAlign: 'center' }}>
              <Typography color="text.primary">
                {timedPeriod.nameWithEvents || camp.label}
              </Typography>
            </Box>
          </Card>
          : <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
            {/* GÓRA */}
            <Box
              sx={{
                backgroundColor: 'primary.main',
                color: 'white',
                px: 2,
                py: 1.5,
                textAlign: 'center'
              }}
            >
              <Typography variant="h6">
                OL - {resort}
              </Typography>
            </Box>

            {/* DÓŁ */}
            <Box sx={{ px: 2, py: 2, textAlign: 'center' }}>
              <Typography color="text.primary">
                {timedPeriod.nameWithEvents || camp.label}
              </Typography>
              <Divider sx={{ m: 1 }} />
              {/* Suma punktów SunActive */}
              <Typography variant="body1" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                Suma punktów SunActive: <span style={{ color: '#388e3c' }}>{sunActivePoints}</span>
              </Typography>

              {/* Szczegóły punktów SunActive */}
              <Typography variant="subtitle1" style={{ marginTop: '10px', color: '#616161' }}>
                Szczegóły punktów:
              </Typography>

              {/* Nagłówki tabeli */}
              <Stack direction="row" justifyContent="space-between" style={{ marginTop: '10px', fontWeight: 'bold' }} mr={5}>
                <Typography variant="body2" style={{ flex: 1, color: '#424242' }}>Opis</Typography>
                <Typography variant="body2" style={{ flex: 1, color: '#424242', textAlign: 'right' }}>Wartość</Typography>
              </Stack>

              <Divider />

              {/* Lista punktów SunActive */}
              <Stack justifyContent="space-between" spacing={2} style={{ marginTop: '10px' }} mr={5}>
                {camp.sunactive_points.map((s, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    justifyContent="space-between"
                    style={{ padding: '10px', background: '#f5f5f5', borderRadius: '4px' }}
                  >
                    <Typography variant="body2" style={{ flex: 1 }}>
                      {s.description}
                    </Typography>
                    <Typography variant="body2" style={{ flex: 1, textAlign: 'right', fontWeight: 'bold', color: '#00796b' }}>
                      {s.value}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
          </Card>
        }
      </Card>
    );
  });
  const renderZSPeriods = resort => application.zs_timed_periods.map((zp, key) => (
    <Card key={key} sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: '0 12px 20px rgba(0,0,0,0.2)' }} elevation={6}>
      {/* GÓRA */}
      <Box
        sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          px: 2,
          py: 1.5,
          textAlign: 'center'
        }}
      >
        <Typography variant="h6">
                ZS - {resort}
        </Typography>
      </Box>

      {/* DÓŁ */}
      <Box sx={{ px: 2, py: 2, textAlign: 'center' }}>
        <Typography color="text.primary">
          {zp.fixed_date[0]} - {zp.fixed_date[1]}
        </Typography>
      </Box>
    </Card>
  ));

  return (
    <Card>
      <CardContent>
        <Stack justifyContent="center" alignItems="center" spacing={2} mb={2}>
          {!hideSunActivePoints(application) && <Stack direction="row" spacing={5}>
            <Card>
              <CardContent sx={{ backgroundColor: '#D0F2FF' }}>
                <Typography variant="h5" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Łączna suma punktów SunActive w tym sezonie: <span style={{ color: '#388e3c' }}>{application.sun_active_points_sum_per_season}</span>
                </Typography>
              </CardContent>
            </Card>
            <Card>
              <CardContent sx={{ backgroundColor: '#D0F2FF' }}>
                <Typography variant="h5" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Łączna suma punktów SunActive z tej aplikacji: <span style={{ color: '#388e3c' }}>{application.sun_active_points_sum}</span>
                </Typography>
              </CardContent>
            </Card>
          </Stack>}
        </Stack>
        <Divider flexItem />
        <Stack direction="row" flex ml="20vh" mr="20vh">
          <Card sx={{ width: '100%' }}>
            <CardHeader title={<Card><CardContent>Mrówki</CardContent></Card>} sx={{ textAlign: 'center' }} />
            <CardContent>
              {application.periods_type == 'obozy' ? <Stack direction="row" flexWrap="wrap" justifyContent="center" spacing={2}>
                {renderCamps('Mrówki')}
              </Stack>
                : (application.resort_for_agreement == 1 && application.periods_type == 'zielone_szkoly') ? <Stack direction="row" flexWrap="wrap" justifyContent="center" spacing={2}>
                  {renderZSPeriods('Mrówki')}
                </Stack> : null}
            </CardContent>
          </Card>
          <Divider flexItem orientation="vertical" sx={{ ml: 2, mr: 2, mt: 2 }} />
          <Card sx={{ width: '100%' }}>
            <CardHeader title={<Card><CardContent>Giewartów</CardContent></Card>} sx={{ textAlign: 'center' }} />
            <CardContent>
              {application.periods_type == 'obozy' ? <Stack direction="row" flexWrap="wrap" justifyContent="center" spacing={2}>
                {renderCamps('Giewartów')}
              </Stack>
                : (application.resort_for_agreement == 2 && application.periods_type == 'zielone_szkoly') ? <Stack direction="row" flexWrap="wrap" justifyContent="center" spacing={2}>
                  {renderZSPeriods('Giewartów')}
                </Stack> : null}
            </CardContent>
          </Card>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StaffCamps;
